import { GraphQLBoolean, GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql';

import { TypeNames } from '../../types';
import { TeamInSlack } from '../types';
import User, { UserInput } from '../types/User';
import UserManagePrivacySettings, {
	UserPrivacySettingsInput,
} from '../types/UserManagePrivacySettings';

const MutationRoot = new GraphQLObjectType({
	fields: {
		updateUser: {
			type: User,
			args: {
				id: { type: new GraphQLNonNull(GraphQLString) },
				input: { type: UserInput },
			},
		},
		deleteUserAvatar: {
			description:
				"Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
			type: GraphQLBoolean,
			args: {
				userId: {
					description: "User's Atlassian account ID",
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
		updateUserAvatar: {
			description: 'Upload an Atlassian account avatar.',
			type: new GraphQLObjectType({
				fields: {
					url: { type: GraphQLString },
				},
				name: TypeNames.AVATAR,
				description: 'New avatar URL after uploading successfully',
			}),
			args: {
				userId: {
					description: "User's Atlassian account ID",
					type: new GraphQLNonNull(GraphQLString),
				},
				fileURI: {
					description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
		updateUserPrivacySettings: {
			description: 'Updates a user’s privacy settings.',
			type: UserManagePrivacySettings,
			args: {
				id: { type: new GraphQLNonNull(GraphQLString) },
				input: { type: UserPrivacySettingsInput },
			},
		},
		updateTeamInSlack: {
			type: TeamInSlack,
			args: {
				teamId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				channelId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				usergroupHandle: {
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
		disconnectTeamInSlack: {
			type: TeamInSlack,
			args: {
				teamId: {
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
	},
	name: 'Mutation',
});

export default MutationRoot;
